import React from "react";
import { Box } from "@mui/material";
import Navbar from "../../Components/Navbar";
import HeroSection from "./HeroSection";
import ApproachSection from "./ApproachSection";
import ArchiveSection from "./ArchiveSection";
import ContactSection from "./ContactSection";
import Footer from "../Home/Footer";
import ScrollToTopButton from "../../Components/ScrollToTopButton";
import useMetaTags from "../../Hooks/UseMetaTags";

const InterriorSection = () => {
  useMetaTags({
    title: "Premium Interior Design Services",
    description: "Transform your living spaces with Abilio Realty's bespoke, museum-quality interior design services. Expert space planning, premium materials, and flawless turnkey execution.",
    keywords: "interior design, luxury spaces, interior decorators, custom millwork, premium home interiors, Abilio Realty",
    ogTitle: "Museum-Quality Interior Design | Abilio Realty",
    ogDescription: "Elevate your home with bespoke materials and timeless luxury spaces crafted by Abilio's award-winning architects.",
  });

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F9FAFB" }}>
      <Navbar />
      <HeroSection />
      <ApproachSection />
      <ArchiveSection />
      <ContactSection />
      {/* Additional interior design sections can be added here */}
      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};

export default InterriorSection;
